// extracted by mini-css-extract-plugin
export default {"preloader":"styles_preloader__lfimr","spinner":"styles_spinner__5z2Cr","spin":"styles_spin__eAVeu"};